import { Component, Input, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BrowserService, ReportingService } from '../../services';
import { Subscription } from 'rxjs';
import { SharePlatform } from '../../services/sharing.service';
import { BrowserMode } from '../../services/browser.service';

@Component({
  selector: 'share-button',
  templateUrl: 'share-button.component.html',
  styleUrls: ['./share-button.component.scss'],
})
export class ShareButtonComponent implements OnInit, OnDestroy {

  // The job being shared
  @Input() job: object;

  // Theme color
  @Input() themeColor: string;

  // Whether or not to use the mobile button
  @Input() useMobileButton: boolean = false;

  // If true, menu goes up, otherwise down
  @Input() openUp: boolean = false;

  // Whether or not to show the share menu
  showMenu: boolean = false;

  // Whether or not to use the modal
  modal: boolean = false;

  // Subscription to the browser service
  browserServiceSubscription: Subscription;

  constructor(
    private browserService: BrowserService,
    private reportingService: ReportingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.browserServiceSubscription = this.browserService.getMode().subscribe((data) => {
        this.modal = false;
        if (data == BrowserMode.Mobile) this.modal = true;
      });
    }
  }

  ngOnDestroy() {
    if (this.browserServiceSubscription) this.browserServiceSubscription.unsubscribe();
  }

  /**
   * Toggles the menu on or off
   * @param { Event } event - click event, if available
   */
  toggleMenu(event: Event) {
    if (event) event.stopPropagation();
    this.showMenu = !this.showMenu;

    // Handle tracking
    const platform: string = this.modal ? 'mobile' : 'desktop';
    const page: string = this.openUp ? 'details' : 'results';
    const state: string = this.showMenu ? 'open' : 'close';
    this.reportingService.trackCustomEvent(`cp_share_toggle_${page}_${platform}_${state}`);
  }

}
